var _defs, _polygon, _polygon2, _polygon3, _path, _polygon4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWika(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 61.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#16489a;}.a{fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo_WIKA_RGB_blue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "13.8 14.8 23.5 14.8 28.3 34.8 28.3 34.8 29.8 30 31.3 25 34 14.8 42.5 14.8 47.8 34.8 47.8 34.8 53.3 14.8 62.3 14.8 53.3 47.3 44.3 47.3 44.3 47.3 42.3 41.5 40.3 35.3 38.3 28 32.8 47.3 23.5 47.3 13.8 14.8 13.8 14.8 13.8 14.8 13.8 14.8 13.8 14.8"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "67.5 14.8 75.5 14.8 75.5 47 67.5 47 67.5 14.8 67.5 14.8 67.5 14.8 67.5 14.8 67.5 14.8"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "84.3 14.8 92.5 14.8 92.5 26.3 92.5 26.3 92.8 26.5 103.8 14.8 114.5 14.8 101.5 27.5 115.8 47 105.5 47 96.3 33.8 96.3 33.8 92.5 37.5 92.5 47 84.3 47 84.3 14.8 84.3 14.8 84.3 14.8 84.3 14.8 84.3 14.8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M133.8,22.8h0l-.8,2.5-1,2.5-1.5,5.5H137v-1l-3.2-9.5Zm-5.5-8h11.5l12,31.7V47H142l-1.2-3.5-.5-1.7-.5-1.8H128.3L126,47h-9.5l11.8-32.2Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "0 0 165.5 0 165.5 47 156.5 47 156.5 8.3 9 8.3 9 53.3 171.3 53.3 171.3 0 180 0 180 61.5 0 61.5 0 0 0 0 0 0 0 0 0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWika);
export default __webpack_public_path__ + "static/media/logo_wika.8f04ed9b0b63ef58f45f2a059dd11e8b.svg";
export { ForwardRef as ReactComponent };